import React, { useEffect } from "react";
import "./styles.scss";

const Partnership = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth",
    });
  }, []);

  return (
    <div className="partnership">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <img src="/paw.png" alt="Bitcoin Beast Paw" className="logo" />
          <h1>Go Beast Mode{<br></br>}On Brand Loyalty.</h1>
          <p className="subtitle">
            Sponsor a custom bitcoin beast inside Jippi's augmented reality
            bitcoin adventure game and capture real-world engagement.
          </p>
          <div className="cta-buttons">
            <a
              href="https://cal.com/oliver-porter/bitcoin-beast-partnership"
              className="cta-button"
              target="_blank"
              rel="noreferrer"
            >
              Create AR Beast
            </a>
            <a
              className="cta-button outline"
              href="https://x.com/JippiApp/status/1910083658301530429"
              target="_blank"
              rel="noreferrer"
            >
              See Jippi in Action
            </a>
          </div>
        </div>
        <div className="flex-container">
          <img
            src="/beast_group.png"
            alt="Group of beasts"
            className="hero-image"
          />
        </div>
      </section>

      {/* Comparison Section */}
      <section className="comparison">
        <div className="container">
          <h2>Beastify Your Brand</h2>
          <p className="comparison-subtitle">
            We help bitcoin brands acquire, engage, and retain their next
            generation of customers through immersive AR quests and real bitcoin
            rewards.
          </p>
          <div className="comparison-cards">
            <div className="comparison-card traditional">
              <h3>Traditional Ad Channels</h3>
              <ul className="comparison-list">
                <li>Most advertising dollars end up enriching Big Tech</li>
                <li>
                  Bitcoiners are notoriously hard to reach with traditional ads
                </li>

                <li>
                  Ad experiences feel forgettable, unrewarding, and easily
                  ignored
                </li>
                <li>
                  Consumers block, skip, and flee intrusive, privacy-invading
                  ads
                </li>
              </ul>
            </div>
            <div className="comparison-card jippi">
              <h3>Jippi</h3>
              <ul className="comparison-list">
                <li>Advertising dollars empower users, not tech monopolies</li>
                <li>
                  Every Jippi user is energized to experience the BTC ecosystem
                </li>
                <li>
                  Brands become allies, not intrusions, in user adventures
                </li>
                <li>
                  Rewarding geolocation quests drive positive brand experiences
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2>How It Works</h2>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-icon">🐾</div>
              <h3>1. Choose Beast</h3>
              <p>
                Select your bitcoin beast with your company branding, logo, and
                call-to-action.
              </p>
            </div>
            <div className="step-card">
              <div className="step-icon">📍</div>
              <h3>2. Drop In Beast</h3>
              <p>
                Strategic hotspots are chosen at top bitcoin conferences for
                maximum exposure.
              </p>
            </div>
            <div className="step-card">
              <div className="step-icon">🎮</div>
              <h3>3. Engage Players</h3>
              <p>
                Players catch your beast and interact with your brand while
                earning bitcoin rewards.
              </p>
            </div>
            <div className="step-card">
              <div className="step-icon">📈</div>
              <h3>4. Track Results</h3>
              <p>
                See engagement metrics like impressions & click-through rate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Bitcoin 2025 Section */}
      <section className="bitcoin-2025">
        <div className="container">
          <h2>Upcoming Beast Catch Events</h2>
          <p className="subtitle">
            Players hunt for bitcoin beasts at some of the world's largest
            bitcoin conferences.
          </p>

          <div className="event-locations">
            <div className="event-banner">
              <img
                src="/bitcoin-2025.jpg"
                alt="Bitcoin 2025 Las Vegas"
                className="event-image"
              />
            </div>

            <div className="event-footer">
              <p>
                Create an AR beast for 30k bitcoiners at The Venetian, Las Vegas
                • May 27-29, 2025
              </p>
              <a
                href="https://cal.com/oliver-porter/bitcoin-beast-partnership"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                Create AR Beast
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing">
        <div className="container">
          <h2>Transparent Pricing</h2>
          <div className="pricing-cards">
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Beastly Package</h3>
                <div className="price">$2,000</div>
              </div>
              <ul className="pricing-list">
                <li>
                  Get your brand in front of 22k bitcoiners with a custom AR
                  beast
                </li>
                <li>Online exposure from bitcoin media like BitcoinNews.com</li>
                <li>
                  Boosted coverage from outlets like AP News, Business Insider,
                  and more
                </li>
                <li>
                  You provide a logo, copy, and CTA URL for an in-game AR
                  campaign
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Where do you run beast catch?</h3>
              <p>
                We place bitcoin beasts at some of the world's largest bitcoin
                conferences. Bitcoin 2025 Las Vegas is the next active game
                territory.
              </p>
            </div>
            <div className="faq-item">
              <h3>How many bitcoin beasts are there?</h3>
              <p>
                At each event, bitcoin companies have the unique opportunity to
                sponsor 1 of 6 exclusive augmented reality bitcoin beasts.
              </p>
            </div>
            <div className="faq-item">
              <h3>How does Jippi choose partners?</h3>
              <p>
                We handpick a small number of partnerships to ensure perfect
                brand alignment, offering a one-of-a-kind interactive experience
                for users and maximum visibility for your company.
              </p>
            </div>
            <div className="faq-item">
              <h3>What kind of analytics do you provide?</h3>
              <p>
                We provide player interactions and click-through rates for your
                in-game AR campaign, as well as online impressions from our
                bitcoin media partners.
              </p>
            </div>
            <div className="faq-item">
              <h3>What do I get in the beastly package?</h3>
              <p>
                We offer an AR bitcoin beast with a custom call-to-action for
                your company, in-person impressions of up to 30k bitcoiners, and
                boosted online brand exposure from our bitcoin media partners.
              </p>
            </div>
            <div className="faq-item">
              <h3>What do players see in Jippi?</h3>
              <p>
                Once players enter the geofenced hotspot with their phone, they
                will see your customized CTA with logo, copy, and URL to your
                website. Then, they get the option to catch your custom AR
                bitcoin beast in exchange for 1k sats!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <img src="/unchained.png" alt="Phone" className="image" />
        <div className="container">
          <h2>Ready to Reach Bitcoiners?</h2>
          <p>Talk to the team to set up your bitcoin beast campaign.</p>
          <a
            href="https://cal.com/oliver-porter/bitcoin-beast-partnership"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Talk to Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default Partnership;
